<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
      <el-form-item label="手机号">
        <el-input style="width: 200px" v-model="queryForm.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getAbnormalUserList">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
        </div>
        <div class="icon-group">
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshAbnormalUserList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        :data="abnormalUserList"
        row-key="id"
        border
        height="100%"
        :header-row-style="{height: '10px'}"
        :header-cell-style="{padding: '10px'}"
        :row-style="{height: '9px'}"
        :cell-style="{padding: '9px'}"
        size="small"
        v-loading="loading"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="userHeader"
          label="头像"
        >
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.userHeader"
              style="width: 40px; height: 40px"
              :src="scope.row.userHeader"
              :preview-src-list="[scope.row.userHeader]"
            ></el-image>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="userName" label="账号"/>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="userMobile" label="手机号" />
        <el-table-column :show-overflow-tooltip="true" align="center" prop="userNickname" label="昵称" />
        <el-table-column :show-overflow-tooltip="true" align="center" label="限制状态">
          <template slot-scope="scope">
            <el-input 
              v-model="scope.row.restrictStatus" 
              placeholder="请输入限制状态"
              size="small"
              @input="handleNumberInput(scope.row, $event)"
              @blur="handleBlur(scope.row)"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { Refresh, Search } from '@v2icons/tabler';
import { get, post } from '@/utils/request.js';

export default {
  components: {
    Refresh,
    Search
  },
  data() {
    return {
      queryForm: {
        phone: '' // 手机号
      },
      loading: false,
      isSearch: false,
      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
      abnormalUserList: []
    };
  },
  created() {
    this.getAbnormalUserList();
  },
  methods: {
    // 搜索box
    search() {
      this.isSearch = !this.isSearch;
    },
    resetAbnormalUserList() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.abnormalUserList = [];
    },
    resetDialog() {
      this.queryForm.phone = '';
      this.getAbnormalUserList();
    },
    refreshAbnormalUserList() {
      this.resetAbnormalUserList();
      this.getAbnormalUserList();
    },
    // 获取列表信息
    getAbnormalUserList() {
      this.loading = true;
      get(`/user/queryList`, {
        ...this.queryForm,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }).then((res) => {
        this.loading = false;
        if (res.success) {
          this.abnormalUserList = res.list.list;
          this.totalNum = res.list.total;
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    currentChange(page) {
      this.currentPage = page;
      this.getAbnormalUserList();
    },
    sizeChange(size) {
      this.pageSize = size;
      this.getAbnormalUserList();
    },
    // 限制只能输入0或1
    handleNumberInput(row, value) {
      // 只保留0或1
      const numericValue = value.replace(/[^01]/g, '');
      // 如果输入了多个字符，只保留最后一个
      if (numericValue.length > 1) {
        row.restrictStatus = numericValue.slice(-1);
      } else {
        row.restrictStatus = numericValue;
      }
    },
    // 离焦后调用接口保存
    handleBlur(row) {
        get(`/user/updateById`, {
          id: row.id,
          restrictStatus: Number(row.restrictStatus)
        }).then((res) => {
          if (res.success) {
            this.$message({
              message: '保存成功',
              type: 'success',
              duration: 2000
            });
          } else {
            this.$message({
              message: res.msg || '保存失败',
              type: 'error',
              duration: 2000
            });
            // 保存失败时重新加载数据
            this.getAbnormalUserList();
          }
        }).catch(() => {
          this.$message({
            message: '保存失败',
            type: 'error',
            duration: 2000
          });
          // 保存失败时重新加载数据
          this.getAbnormalUserList();
        });
      
    }
  }
};
</script>

<style lang="scss" scoped>
.count {
  font-size: 14px;
  margin-left: 10px;
  padding: 0 4px;
}
</style>

